import React, { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const CATS = [
  { id: "all", label: "All" },
  { id: "facilities", label: "Facilities" },
  { id: "aircraft", label: "Aircraft" },
  { id: "infrastructure", label: "Historic / Infrastructure" },
  { id: "events", label: "Events" },
];

export default function Gallery() {
  const [photos, setPhotos] = useState([]);
  const [cat, setCat] = useState("all");
  const [active, setActive] = useState(null);

  useEffect(() => { api.get("/photos").then((r) => setPhotos(r.data)); }, []);

  const filtered = useMemo(
    () => (cat === "all" ? photos : photos.filter((p) => p.category === cat)),
    [photos, cat]
  );

  return (
    <div data-testid="gallery-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 anim-fadeup">
      <div className="section-label">Gallery</div>
      <h1 className="font-display font-bold text-4xl sm:text-5xl text-slate-950 mt-3">Facilities & aircraft.</h1>

      <div className="mt-8 flex flex-wrap gap-2">
        {CATS.map((c) => (
          <button
            key={c.id}
            data-testid={`gallery-filter-${c.id}`}
            onClick={() => setCat(c.id)}
            className={`px-4 py-2 text-xs font-mono uppercase tracking-widest border transition-colors ${
              cat === c.id ? "bg-slate-950 text-white border-slate-950" : "bg-white text-slate-700 border-slate-300 hover:border-slate-950"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
        {filtered.map((p) => (
          <button
            key={p.id}
            data-testid={`gallery-item-${p.id}`}
            onClick={() => setActive(p)}
            className="group relative aspect-[4/3] overflow-hidden bg-slate-100"
          >
            <img src={p.image_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
              <div className="text-left">
                <div className="text-xs font-mono uppercase tracking-widest text-sky-300">{p.category}</div>
                <div className="font-display text-white font-semibold">{p.title}</div>
              </div>
            </div>
          </button>
        ))}
        {filtered.length === 0 && <div className="col-span-full text-slate-500">No photos in this category yet.</div>}
      </div>

      {active && (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-50 bg-slate-950/95 flex items-center justify-center p-6"
        >
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={active.image_url} alt={active.title} className="w-full max-h-[80vh] object-contain bg-black" />
            <div className="mt-4 flex justify-between text-white">
              <div>
                <div className="text-xs font-mono uppercase tracking-widest text-sky-300">{active.category}</div>
                <div className="font-display text-2xl font-semibold">{active.title}</div>
                <div className="text-sm text-slate-300 mt-1">{active.caption}</div>
              </div>
              <button data-testid="lightbox-close" onClick={() => setActive(null)} className="text-sm font-mono uppercase tracking-widest border border-white/30 px-4 py-2 hover:bg-white/10">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
